import { useSyncExternalStore } from 'react';
import { getSoundStatus, subscribeSoundStatus, type SoundStatus } from './sound';

/**
 * Стан звукового набору для UI.
 *
 * `useSyncExternalStore`, а не `useState` + `useEffect`: менеджер звуку живе
 * поза React (його викликають із обробників кліків, з таймерів, з Howler), і
 * саме цей хук існує для такого джерела. Самописна підписка тут дала б
 * розсинхрон між тим, що показано, і тим, що насправді сталося.
 */
export function useSoundStatus(): SoundStatus {
  return useSyncExternalStore(subscribeSoundStatus, getSoundStatus, () => 'unknown');
}
